import { MouseEvent } from 'react';
import { useNavigate, useHref, type To } from 'react-router-dom';

export const useStickySafeNavigate = () => {
  const navigate = useNavigate();

  return (path: string) => {
    window.scrollTo(0, 0);

    navigate(path);
  };
};

export function useProgrammaticLink(to: To) {
  const url = useHref(to);

  const clickLink = (event?: MouseEvent<HTMLElement> | MouseEvent) => {
    const anchor = document.createElement('a');
    anchor.href = url;

    const mouseEvent = new window.MouseEvent('click', {
      ctrlKey: event?.ctrlKey ?? false,
      shiftKey: event?.shiftKey ?? false,
      metaKey: event?.metaKey ?? false,
      altKey: event?.altKey ?? false,
      bubbles: true,
      cancelable: true,
      view: window,
    });

    anchor.dispatchEvent(mouseEvent);
  };

  return clickLink;
}
